module.exports = __webpack_public_path__ + "static/logoOKE-8e5804a026f94f7e19f1d821fdc8c57d.svg";